import routerinfo from '~/constants/routerinfo'
// path 정규화
function normalizePath(path = '') {
    if (typeof path !== 'string') return '/'
    const cleaned = path.split('?')[0].split('#')[0].trim()
    if (!cleaned) return '/'
    if (cleaned === '/') return '/'
    return cleaned.replace(/\/+$/, '')
}
// 배열 내 경로를 정규화하고 중복 제거
function uniq(arr = []) {
    return [...new Set(arr.map(normalizePath).filter(Boolean))]
}

export const GUEST_ONLY_PATHS = uniq([
    // 비회원 허용경로
    "/Login",
    "/SignUp"
])

export const PUBLIC_PATHS = uniq([
    // 비회원/준회원/정회원 허용경로
    ...(routerinfo['allow-nomember'] || []),
])

export const MEMBER_ALLOWED_PATHS = uniq([
    // 준회원/정회원 허용 경로
    "/MyPage",
])
// 현재 path가 targets 목록 중 하나와 매칭되는지 확인
function matchPath(path = '', targets = []) {
    const current = normalizePath(path)

    return targets.some((target) => {
        const base = normalizePath(target)
        if (!base) return false
        return current === base || (base !== '/' && current.startsWith(`${base}/`))
    })
}
// 현재 라우트의 접근 권한 타입 반환
export function getRouteAccess(path = '') {
    const current = normalizePath(path)

    if (matchPath(current, GUEST_ONLY_PATHS)) return 'guestOnly'
    if (matchPath(current, PUBLIC_PATHS)) return 'public'
    if (matchPath(current, MEMBER_ALLOWED_PATHS)) return 'member'
    return 'regular'
}